import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import powerappsRoutes from './powerapps/powerapps.routes';
import powerAgentsRoutes from './settings/powerAgents/powerAgents.routes';
import powerDataRoutes from './settings/powerData/powerData.routes';
import powerflowRoutes from './powerflow/powerflow.routes';
import kanbanRoutes from './kanban/kanban.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';
import OauthConsent from '../oauth/Consent.vue';
import TestLinkTeamPass from '../testLink/TeamPass.vue';
import OnboardingAccountDetails from './onboarding/Index.vue';
import homeRoutes from './home/home.routes';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        // A Home vive DENTRO do shell: o launcher e a visao geral de uso da org
        // precisam da sidebar e do topbar como qualquer outra tela. Fora do
        // AppContainer ela renderizava sozinha na viewport, sem navegacao.
        ...homeRoutes.routes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...powerappsRoutes.routes,
        ...kanbanRoutes.routes,
        // FLOW-06 (SPEC S5): a aba PowerFlow, no casco, como o kanban; os endereços de Configurações ›
        // PowerTools redirecionam para ela.
        ...powerflowRoutes.routes,
      ],
    },
    ...powerappsRoutes.standaloneRoutes,
    // A tela de um agente ocupa a viewport inteira, como um PowerApp. As rotas nested de
    // PowerAgents continuam chegando por `settings.routes`; só esta é irmã do AppContainer.
    ...powerAgentsRoutes.standaloneRoutes,
    // O PowerData inteiro é standalone — a lista de bases e a base. Ao contrário do
    // PowerAgents, aqui nem a LISTA fica no shell: as duas telas são o mesmo ambiente, e
    // sair da base para a lista não deveria trocar de moldura no meio do caminho.
    ...powerDataRoutes.standaloneRoutes,
    // O editor de flow (FLOW-01) também: código, documentação e problemas pedem a largura toda. Desde
    // a FLOW-06 ele mora na aba PowerFlow, com os redirects dos endereços antigos.
    ...powerflowRoutes.standaloneRoutes,
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role', 'moderator'],
        // ACESSO-01 (L8b): de todo membro da conta (`helper/routeHelpers`, `rotaAbertaPelosEscopos`).
        escopos: [],
      },
      component: OnboardingAccountDetails,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role', 'moderator'],
        // ACESSO-01 (L8b): de todo membro da conta (`helper/routeHelpers`, `rotaAbertaPelosEscopos`).
        escopos: [],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
    {
      // Fora de :accountId de propósito: o consentimento é do usuário, e o
      // cliente que abre este endereço não conhece conta nenhuma.
      path: frontendURL('oauth/authorize'),
      name: 'oauth_consent',
      meta: { accountAgnostic: true },
      component: OauthConsent,
    },
    {
      // AGENTS-LINK-01 (L-11): a entrada da equipe no link de teste. Fora de :accountId porque a
      // conta vem do link, cujo token chega no fragmento. A página `/t` aponta para cá
      // (`TestLinks::AcessosController::ENTRADA_DA_EQUIPE`).
      path: frontendURL('test-link'),
      name: 'test_link_team_pass',
      meta: { accountAgnostic: true },
      component: TestLinkTeamPass,
    },
  ],
};
